"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
class Notifications {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * Get messages for push-messages service
    The salt must be unique for each request and be greater than the previous ones. The best solution would be to use a timestamp for this.
    The sign is formed using the following formula:
    sign = md5(upFromMessageId.ToString()+take.ToString+salt.ToString()+secret_key);
    Encoding for md5 string - ASCII;
    If something is incorrect, it returns a 401 code.
    * @returns {Promise<ResultFail|Array<NotificationMessageDTO>|net.NetError|number>}
    */
    getMessagesForPushServiceUnsafe(upFromMessageId, take, salt, sign) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Notifications/GetMessagesForPushService";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("upFromMessageId=" + encodeURIComponent(upFromMessageId));
            __query.push("take=" + encodeURIComponent(take));
            __query.push("salt=" + encodeURIComponent(salt));
            __query.push("sign=" + encodeURIComponent(sign));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.NotificationMessageDTO(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get messages for push-messages service
    The salt must be unique for each request and be greater than the previous ones. The best solution would be to use a timestamp for this.
    The sign is formed using the following formula:
    sign = md5(upFromMessageId.ToString()+take.ToString+salt.ToString()+secret_key);
    Encoding for md5 string - ASCII;
    If something is incorrect, it returns a 401 code.
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<NotificationMessageDTO>>}
    */
    getMessagesForPushService(upFromMessageId, take, salt, sign, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.getMessagesForPushServiceUnsafe(upFromMessageId, take, salt, sign);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.Notifications = Notifications;
//# sourceMappingURL=Notifications.js.map